import React from 'react';
import { GridTableContext } from '../contexts';
import { CustomPagination } from './custom-pagination.component';

export function Pagination(): JSX.Element {
  const {
    instance: {
      state: { pageSize }
    },
    totalRows
  } = React.useContext(GridTableContext);

  return <CustomPagination pageCount={Math.ceil(totalRows / pageSize)} totalRows={totalRows} />;
}
